

import React from 'react';
import { RiShareLine } from 'react-icons/ri';
import referImage from '../../../assets/refer.png';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileMyReferal = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(0);
  };
  return (
    <>
      <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
        <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
          <FaArrowLeft className="text-lg" />
        </button>
        <h1 className="text-xl font-semibold">My Referral</h1>
      </div>
      <div className="w-full mx-auto p-6 bg-white rounded-lg mt-2">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold text-gray-700">Referral & Earn</h2>
          <div className="bg-orange-100 text-[#FF9630] px-4 py-1 rounded-full text-sm font-semibold">
            Total Referrals: <span>22</span>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex justify-center mb-6">
          <img src={referImage} alt="Referral illustration" className="w-full max-w-xs" />
        </div>

        {/* Referral Link Section */}
        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
          <input
            type="text"
            readOnly
            value="moveonwheels.com/?refer=Ranjita00123"
            className="flex-grow p-3 text-gray-600 outline-none"
          />
          <button className="bg-[#FF9630] text-white px-4 py-4 font-semibold flex items-center">
            <RiShareLine className="w-5 h-5 mr-1" />
            SHARE
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileMyReferal;
